import { EProjects } from 'src/app/shared/enums/projects.enum';
import * as get from 'lodash.get';
import { ERoutes } from 'src/app/checkin-app/modules/checkin/pages/guests/enums/routes.enum';
import { TProject } from 'src/app/shared/models/projects/project.model';

function messagesHandler(send: (p: any) => void, res: any) {
  this.config.inbox.messages.load(res.messages, (unread: number) => {
    const project: TProject = this.config[this.config.project];
    const isInboxProject: boolean = this.config.project === EProjects.INBOX;
    const path: string = get(this.activatedRoute, 'firstChild.firstChild.firstChild.routeConfig.path', '');
    const isInboxPath: boolean = {
      [ERoutes.INBOX]: true,
      [ERoutes.COMMENTS]: true
    }[path];

    project.setNotification([ERoutes.INBOX, ERoutes.COMMENTS] as any[], ((isInboxProject || isInboxPath) ? 0 : unread));
  });
}

export default messagesHandler;
